// extracted by mini-css-extract-plugin
export default {"edit_your_box":"Gh","edit_box_title":"Hh","subscription":"Ih","byb":"Jh","recommended_for_you_title":"Kh","explore":"Lh","recommended":"Mh","go_back":"Nh","wrapper":"Oh","product_img":"Ph","info":"Qh","remove_btn":"Rh"};
    if(module.hot) {
      // 1713969922570
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  